module.exports = __webpack_public_path__ + "img/主营业务_能源系统集成03.3e2ef7d2.png";